export default __webpack_public_path__ + "static/media/oral-aesthetics.f2aa95d9.svg";